import constants from '@/store/modules/shippingLabelPage/constants';

export default {
  [constants.mutationTypes.shippingInfoWasLoaded](state) {
    state.loading = false;
  },
};
